<template>
  <div class="aside">
    <el-scrollbar>
      <div v-for="item in navData" :key="item.path" class="menu">
        <div class="menu-box">
          <Icon :icon="item.icon" class="icon"></Icon>
          <span class="title">{{ item.name }}</span>
        </div>
        <div v-for="subItem in item.children" :key="subItem.path" class="sub-menu-box"
             :class="$route.path === subItem.path ? 'sub-menu-active' : ''"
             @click.prevent="handleGoRouter(subItem.path)">
          <div class="icon-box">
            <Icon v-if="$route.path === subItem.path" :icon="subItem.icon" class="icon"></Icon>
          </div>
          <a :href="subItem.path" class="title">{{ subItem.name }}</a>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: 'Aside',
  props: {
    sideList: Array,
  },

  data () {
    return {
    }
  },
  computed: {
    navData () {
      return this.sideList
    },
  },
  methods: {
    handleGoRouter (path) {
      this.$router.push({ path })
    },
  },
}
</script>

<style lang="scss" scoped>
  .aside{
    background: #F1F2F5;
    height: 100%;
    width: 220px;
    overflow: auto;
    padding-bottom: 80px;
    .menu{
      padding: 20px 0 0 20px;
      .menu-box{
        padding-bottom: 21px;
        padding-left: 23px;
        font-size: 16px;
        font-weight: bold;
        color: #1C1C1C;
        .icon{
          font-size: 24px;
        }
      }
      .sub-menu-box{
        padding: 16px 0 15px 31px;
        cursor: pointer;
        .icon-box{
          width: 14px;
          margin-left: -5px;
          display: inline-block;
          .icon{
            font-size: 16px;
          }
        }
        a{
          color: #4E4E4E;
        }
      }
      .sub-menu-active{
          color: #3269FF;
          background: url('https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/common/aside-bg.png') left center no-repeat;
          a{
            color: #3269FF;
          }
        }
    }
    .title{
      margin-left: 10px;
    }
  }
</style>
